import { custom, required } from '@carboledger/ui';
import { getTranslation } from '@/lib/utils/i18n';
import { referenceIdNumberRule } from '@/lib/validation';

// Rules for the allocation modals — `required` lives here so the copy is the doc's own.

// The SD number the declaration is filed under; the server owns its uniqueness.
export const declarationDetailsValidation = {
  idNumber: referenceIdNumberRule,
};

export const allocationsValidation = {
  shipmentId: [
    required(getTranslation('ALLOCATIONS_SHIPMENT_ID_REQUIRED')),
    ...referenceIdNumberRule,
  ],
  unit: [required(getTranslation('ALLOCATIONS_SHIPMENT_UNIT_REQUIRED'))],
  dateOfDispatch: [required(getTranslation('ALLOCATIONS_SHIPMENT_DATE_REQUIRED'))],
};

/**
 * A shipment row's quantity: above zero, and never past what the allocation certified in the
 * unit that row currently has selected — hence the cap reads its unit field. The field itself
 * carries the required rule, so its message stays with the control.
 */
export const buildShipmentQuantityRules = (rawByUnit, unitFieldName) => [
  custom((value) => Number(value) > 0, getTranslation('ALLOCATIONS_SHIPMENT_QUANTITY_POSITIVE')),
  custom((value, values) => {
    const cap = rawByUnit?.[values[unitFieldName]];
    return cap == null || Number(value) <= cap;
  }, getTranslation('ALLOCATIONS_SHIPMENT_QUANTITY_OVER_ALLOCATED')),
];
